import React from 'react';
import { CloseSquareOutlined } from '@ant-design/icons';
import classes from "./ClearFilters.module.css";

const ClearFilters = ({ activeFilters, clearFilters }) => {

    let sliderValueContent;
    if(!activeFilters.sliderValue || activeFilters.sliderValue === 0)
    {
        sliderValueContent = 'All'
    }
    else
    {
        if(activeFilters.sliderValue === 5)
        {
            sliderValueContent = activeFilters.sliderValue
        }
        if(activeFilters.sliderValue<5)
        {
            sliderValueContent = 'more than ' + activeFilters.sliderValue
        }
    }

  return (
    <div className={classes.container}>
    <span>Filtry </span>
      <span className={classes.span}><strong>Tytuł</strong>: {activeFilters.title}</span>
      <span className={classes.span}><strong>Ocena</strong>: {sliderValueContent}</span>
      <CloseSquareOutlined className={classes.closeButton} onClick={clearFilters}/>
    </div>
  );
};

export default ClearFilters;
